import React from 'react';
import { useLoaderData } from 'react-router-dom';
import { graphql } from 'relay-runtime';
import { PreloadedQuery, usePreloadedQuery, useQueryLoader } from 'react-relay';
import Email from './Email';
import type {
  LoginCreateAccountEmailPreloaderQuery as LoginCreateAccountEmailPreloaderQueryType,
  LoginCreateAccountEmailPreloaderQuery$data as LoginCreateAccountEmailPreloaderQueryResponse,
} from './__generated__/LoginCreateAccountEmailPreloaderQuery.graphql';

export const CreateAccountPrefillQuery = graphql`
  query LoginCreateAccountEmailPreloaderQuery(
    $email: String
    $encryptedEmail: String
  ) {
    hubspotLead(email: $email, encryptedEmail: $encryptedEmail) {
      email
      firstName
      lastName
    }
  }
`;

const EmailPreloader = () => {
  const loaderQueryReference = useLoaderData() as PreloadedQuery<
    LoginCreateAccountEmailPreloaderQueryType,
    LoginCreateAccountEmailPreloaderQueryResponse
  >;
  const [queryReference] =
    useQueryLoader<LoginCreateAccountEmailPreloaderQueryType>(
      CreateAccountPrefillQuery,
      loaderQueryReference
    );
  const prefillData =
    usePreloadedQuery<LoginCreateAccountEmailPreloaderQueryType>(
      CreateAccountPrefillQuery,
      queryReference as PreloadedQuery<
        LoginCreateAccountEmailPreloaderQueryType,
        LoginCreateAccountEmailPreloaderQueryType
      >
    );

  return (
    <Email
      email={prefillData.hubspotLead?.email}
      firstName={prefillData.hubspotLead?.firstName}
      lastName={prefillData.hubspotLead?.lastName}
    />
  );
};

export default EmailPreloader;
